export class DateCell {
	constructor(public Start: Date, public End: Date, public Index: number, public Selected?: boolean) { }
}